/**
 * API de autenticación usando Axios.
 * Reemplaza llamadas a AuthenticateApi (OpenAPI).
 */
import { axiosInstance } from "features/shared/api";
import type {
    ChangePasswordRequest,
    CreateVerificationTokenRequest,
    RecoverPasswordRequest,
    RecoverPasswordResponse,
    ResetPasswordRequest,
} from "common/models";

export const authApi = {
    recoverPassword: (body: RecoverPasswordRequest) =>
        axiosInstance.post<RecoverPasswordResponse>("/api/auth/recover-password", body),

    resetPassword: (body: ResetPasswordRequest) =>
        axiosInstance.post("/api/auth/reset-password", body),

    verifyEmail: (token: string) =>
        axiosInstance.post("/api/auth/verify-email", { token }),

    // TODO: move to users api
    resendEmailVerification: (body: CreateVerificationTokenRequest) =>
        axiosInstance.post("/api/users/resend-verification-token", body),

    changePassword: (body: ChangePasswordRequest) =>
        axiosInstance.post("/api/auth/change-password", body),
};
